export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__text">
        © 2026 Jesinthan Joseph Durairaj | Built with ❤️ in React
      </p>
    </footer>
  );
}
